// extracted by mini-css-extract-plugin
module.exports = {"cncEditableTableFormBtn":"cnc-editable-table-form-btn--cncEditableTableFormBtn--31Qamxy"};